import { css } from 'linaria'

import { breakpoints, rel } from '../styles/dimensions'
import * as colors from '../styles/colors'


export const content = css`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${rel(24)}rem;
  align-items: start;

  @media screen and (min-width: ${breakpoints.lg}) {
    grid-template-columns: minmax(0, ${rel(520)}rem) minmax(0, 1fr);
  }
`

export const form = css`
  padding: ${rel(24)}rem;
  background-color: ${colors.backgroundColor[3]};
  border: ${rel(1)}rem solid ${colors.backgroundColor[1]};
  border-radius: ${rel(6)}rem;

  > * + * {
    margin-top: ${rel(16)}rem;
  }
`

export const actions = css`
  display: flex;
  justify-content: flex-end;
`

export const userSelect = css`
  min-width: 0;

  > div {
    min-width: 0;
  }

  select {
    display: block;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`

export const guide = css`
  min-width: 0;
  padding: ${rel(24)}rem;
  background-color: ${colors.backgroundColor[3]};
  border: ${rel(1)}rem solid ${colors.backgroundColor[1]};
  border-radius: ${rel(6)}rem;

  h2 {
    margin: 0 0 ${rel(12)}rem;
    font-size: ${rel(22)}rem;
  }

  p {
    margin: 0 0 ${rel(16)}rem;
  }

  code {
    overflow-wrap: anywhere;
  }
`

export const tableWrapper = css`
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: ${rel(13)}rem;
  }

  th,
  td {
    padding: ${rel(8)}rem;
    text-align: left;
    vertical-align: top;
    border: ${rel(1)}rem solid ${colors.backgroundColor[1]};
  }

  th {
    background-color: ${colors.backgroundColor[2]};
  }
`
